import type { FramingComponentEntityTable, FramingComponentId } from "building-types/framing/framingComponentTypes";
import { LumberProfileType } from "building-types/framing/lumberTypes";
import { framingComponentWithLumberProfile } from "./framingComponents";

export function defaultLumberComponentId(profileType: LumberProfileType): FramingComponentId {
  switch (profileType) {
    case LumberProfileType.SPF_2X4:
      return "default2x4";
    case LumberProfileType.SPF_2X6:
      return "default2x6";
    case LumberProfileType.SPF_2X8:
      return "default2x8";
    case LumberProfileType.SPF_2X10:
      return "default2x10";
    case LumberProfileType.SPF_2X12:
      return "default2x12";
    default:
      return "default2x4";
  }
}

export const default2x4Id = defaultLumberComponentId(LumberProfileType.SPF_2X4);
export const default2x6Id = defaultLumberComponentId(LumberProfileType.SPF_2X6);
export const default2x8Id = defaultLumberComponentId(LumberProfileType.SPF_2X8);
export const default2x10Id = defaultLumberComponentId(LumberProfileType.SPF_2X10);
export const default2x12Id = defaultLumberComponentId(LumberProfileType.SPF_2X12);

const defaultLumberComponents = {
  [default2x4Id]: framingComponentWithLumberProfile("2x4 Lumber", LumberProfileType.SPF_2X4, default2x4Id),
  [default2x6Id]: framingComponentWithLumberProfile("2x6 Lumber", LumberProfileType.SPF_2X6, default2x6Id),
  [default2x8Id]: framingComponentWithLumberProfile("2x8 Lumber", LumberProfileType.SPF_2X8, default2x8Id),
  [default2x10Id]: framingComponentWithLumberProfile("2x10 Lumber", LumberProfileType.SPF_2X10, default2x10Id),
  [default2x12Id]: framingComponentWithLumberProfile("2x12 Lumber", LumberProfileType.SPF_2X12, default2x12Id),
};

/** Built-in dimensional lumber catalog only (no I-joist built-ins). */
export const builtInDimensionalLumberFramingComponents: FramingComponentEntityTable = defaultLumberComponents;

export function isBuiltInDimensionalLumberComponent(id: FramingComponentId): boolean {
  return Object.keys(defaultLumberComponents).includes(id);
}
